export const general = {
  POLLING_INTERVAL: 1000,
  HAS_MIXPANEL_ACCESS: process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
}
